module.exports = __webpack_public_path__ + "static/media/produ.6ba30c3e.png";